"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("../styles/_package-details.scss");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function PackageDetails(_ref) {
  var subPackage = _ref.subPackage;

  if (!subPackage) {
    return _react.default.createElement("span", {
      className: "package-details__field"
    }, "-");
  }

  var templatedFrom = subPackage.templatedFrom,
      slaTurnaround = subPackage.slaTurnaround,
      videoQuantity = subPackage.videoQuantity,
      amendmentsQuantity = subPackage.amendmentsQuantity;
  return _react.default.createElement("div", {
    className: "package-details"
  }, _react.default.createElement("span", {
    className: "package-details__field"
  }, templatedFrom.toLowerCase()), _react.default.createElement("span", {
    className: "package-details__field"
  }, "".concat(slaTurnaround, "h")), _react.default.createElement("span", {
    className: "package-details__field"
  }, "".concat(videoQuantity, " Videos")), _react.default.createElement("span", {
    className: "package-details__field"
  }, "".concat(amendmentsQuantity, " Amendments")));
}

var _default = (0, _react.memo)(PackageDetails);

exports.default = _default;